import React from 'react';
import PageBreadcrumb from '@/components/common/PageBreadCrumb';
import PageMeta from '@/components/common/PageMeta';
import { MenuOrderSettings } from '@/features/profile/components/MenuOrderSettings';
import { defaultNavItems } from '@/app/layout/AppSidebar';
import { useMenuOrder } from '@/shared/hooks/useMenuOrder';
import { useTranslation } from 'react-i18next';

const SettingsPage: React.FC = () => {
  const { items, saveOrder } = useMenuOrder(defaultNavItems);
  const { i18n, t } = useTranslation();

  const handleLanguageChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    i18n.changeLanguage(e.target.value);
  };

  return (
    <>
      <PageMeta
        title={t('settings.title')}
        description={t('settings.description')}
      />
      <PageBreadcrumb
        items={[
          { label: t('settings.breadcrumb') }
        ]}
        pageTitle={t('settings.breadcrumb')}
      />

      <div className="grid grid-cols-1 lg:grid-cols-2 w-full gap-4 md:gap-6 2xl:gap-8" data-testid="settings-page">
        <div className="rounded-2xl border border-border-primary bg-bg-card p-4 md:p-6 xl:p-7.5" data-testid="menu-order-settings-section">
          <MenuOrderSettings items={items} onSave={saveOrder} />
        </div>

        <div className="rounded-2xl border border-border-primary bg-bg-card p-4 md:p-6 xl:p-7.5" data-testid="language-settings-section">
          <div className="flex flex-col gap-6">
            <div className="flex flex-col gap-4">
              <h3 className="text-lg font-medium text-text-primary" data-testid="language-settings-title">{t('settings.language.title')}</h3>
              <p className="text-sm text-text-tertiary" data-testid="language-settings-description">
                {t('settings.language.description')}
              </p>
            </div>

            <div className="max-w-xs">
              <select
                className="w-full rounded-lg border border-border-input bg-bg-input px-4 py-2.5 text-text-primary"
                value={i18n.language}
                onChange={handleLanguageChange}
                data-testid="language-selector"
              >
                <option value="en" data-testid="language-option-en">{t('settings.language.options.english')}</option>
                <option value="fr" data-testid="language-option-fr">{t('settings.language.options.french')}</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SettingsPage;
